
GP.GPMod('Chat',function(self) {
    // add conf and data objects as properties to the parent Chat module
    // to be used in sub modules as configuration and shared state data
    this.on("before:start", function() {
        self.conf = _conf;
        self.data = _data;
    });

    // init sub modules before initializing data/events/chat module
    this.on("start", function() {
        // start submodules so they finish setting up thier vars/references etc
        $.each(self.submodules, function(name, sub_module) {
            sub_module.init_module();
        });

        // setup data and event binds
        _data.init();
        self.events.init();
    });

    // configuration values for the Chat module and it's sub modules
    var _conf = {
        duid_re:     /#DUID#/g,
        streamer_re: /#STREAMER#/g,
        watcher_re:  /#WATCHER#/g,
        token_re:    /#TOKEN#/g,
        cluster_re:  /#CLUSTER#/g,
        // test for new flussonic servers (e.g. live1-ord.gpstreaming.com)
        live_re:     /live[1-5]-ord/g,
        channel: {
            // general chat channels to subscribe to
            admin:         '/chat/admin',
            rooms:         '/service/chat/rooms',
            join_room:     '/service/chat/join_room',
            leave_room:    '/service/chat/leave_room',
            update_expire: '/service/chat/update_user_expire',
            update_videochat_expire: '/service/chat/update_videochat_expire',

            // room specific chat channels to subscribe to
            users:    '/chat/users/#DUID#',
            json:     '/chat/json/#DUID#',
            counts:   '/chat/rooms/user_counts',
            messages: '/chat/messages/#DUID#'
        },
        flussonic: {
            // flussonic urls for publishing/watching
            source:   null,
            restream: null,
            // flussonic's sentry url to help improve webRTC publisher/player
            sentry: "https://225c029cea2a4a0e99a97f5b4ff27f5d@sentry.flussonic.com/19",
        },
        // options for publisher video element
        video_pub_options: {
            autoplay: true,
            controls: true,
            muted: true,
        },

        video_constraints: {
            width:  { min: 320, ideal: 1920, max: 4096 },
            height: { min: 240, ideal: 1080, max: 2160 },
        },

        publisher_debug: false,
        player_debug:    false,

        vchat_publisher_id:  'publisher',
        vchat_player_id:     'profile_vchat_video',

        vchat_publisher_wrap: 'publisher-wrap',
        vchat_player_wrap:    'player-wrap',

        mobile_history_cap: 100,
        debounce_miliseconds: 250,
        max_reload_tries: 3,
        vc_goal_char_limit: 70,
        vc_tip_goal_max: 100000, // max tip goal amount in normal credits
        vc_tip_goal_max_bronze: 4000, // max tip goal amount in BRONZE credits
        vc_reconnecting_timer: 30000, // setTimout time for showing reconnecting notice/spinner

        // height in pixels that will be subtracted from document.height for what we consider "scrolled" to the bottom
        mobile_scroll_height_margin: 100,

        // timer name and interval to check chat connection status
        timer_sc: 'chat_status_check',
        timer_ue: 'chat_update_expire',
        timer_cps: 'chat_check_publisher_stream',
        timer_vr: 'chat_videochat_reconnecting',
        timer_ticket_info_timer: 'chat_videochat_ticket_info_timer',
        timer_interval: 30000,

        // allowed types of videochat rooms
        vc_room_types: ['NORMAL', 'TICKET', 'PPM', 'PRIVATE'],

        timer_check_stream: 'vc_check_stream',

        // chat error cookie expires (in days)
        error_cookie_exp: 1,
        error_cookie: 'wec',

        // determine which push server user is connected to and send with ajax calls, so php can use same server
        api_url: "http://push.gpstreaming.fling.com:" + _push_port + "/rt/api",

        event_namespace: 'chat_binds',

        large_pic_re:  /-L.jpg/,
        medium_pic_re: /-M.jpg/,

        chat_ajax_module:  'chat.publish_json',
        vchat_ajax_module: 'videochat.publish',

        // signify if we are in single room mode, or multi room mode
        single_room: false,

        // the room id of the main/only room to join for when we are running chat as a single room
        main_room_id: 1,

        vchat_publisher_swf: '/videochat/publish-v41.swf',

        // vchat_tip_sound: '/videochat/sounds/tip_sound_1.mp3',
        // vchat_tip_sound: '/videochat/sounds/tip_sound_2.mp3',
        // vchat_tip_sound: '/videochat/sounds/tip_sound_4.mp3',
        // vchat_tip_sound: '/videochat/sounds/tip_sound_5.mp3',
        vchat_tip_sound: '/videochat/sounds/tip_sound_3.mp3'
    };


    // the data representing the internal state for the Chat module overall (as well as sub modules)
    var _data = {
        // check and initialize a few params
        init: function() {
            // enable autoplay for non mobile/desktop browsers
            if (!self.app.Util.is_mobile()) {
                // _conf.videojs_options.autoplay = true;
            }

            // add ref to _data obj to our application's shared my_user object
            _data.user = GP.sdata.my_user || {};

            // setup emoji and Configure this library to use the sheets defined in `img_sets`
            window.emoji = new EmojiConvertor();
            // emoji.use_sheet = true;
            // emoji.use_css_imgs = true;
            // emoji.allow_native = false;
            // emoji.include_title = true;

            _data.duid     = parseInt(_data.user.duid, 10);
            _data.username = _data.user.username;

            _data.users = new self.app.collections.ChatUsers();
            _data.reset_chat_data();


            // setup audio object for playing tip sounds
            self.vchat.setup_tip_sound();

            // set _data vars for chrome version 60 and if we're on https or not
            // _data.chrome_60 = self.app.Util.check_chrome_60();
            _data.https = self.app.Util.test_https();

            // expose _data obj globally for testing
            window.vidchat_data = _data;

        },
        reset_chat_data: function() {
            // self.app.Util.trace('_data.reset_chat_data called...');

            // default to chat.publish_json
            _data.ajax_module = _conf.chat_ajax_module;

            _data.membership = _data.user.hasOwnProperty('membership') ?
                _data.user.membership.toUpperCase() :
                'FREE';

            _data.free_user = _data.membership == 'FREE' ? true : false;

            // get array of gender's user is seeking to check chat user genders against
            if (_data.user.hasOwnProperty('seeking')) {
                _data.seeking = _data.user.seeking.split(',');
            }

            // if they have "MAN" in their seeking, put them toward the top, otherwise keep the default WOMAN on top
            _data.users.reset();
            if ($.inArray("MAN", _data.seeking) > -1) {
                _data.users.changeSortOrder('man');
            }

            _data.rooms = null;
            _data.current_room = {};
            _data.chat_subscriptions = {};
            _data.room_subscriptions = {};

            _data.is_videochat = false;
            _data.vc = {
                type:          'NORMAL', // NORMAL, TICKET, PPM or PRIVATE
                room_id:       null,     // previously _data.wowza_duid (duid of user who's on camera/streaming/publisher)
                username:      null,     // previously _data.wowza_username
                state:         null,
                tip_sound:     null,
                play_tip_sound: true,
                is_publisher:  false,
                initializing:  false,

                retry_count: 0,
                switch_url: null,

                private_room: false,       // previously _data.private_room (flag for private room or not)
                ppm_cost: 0,
                private_info: {
                    url:              null, // url for private/ppm chats that will use authentication hooks for verification
                    watcher_duid:     null, // previously _data.private_duid (aka watcher_duid/user watching the stream)
                    private_paid:     false, // flag for if user has access to watch the private stream (i.e. did the pay)
                    start_ppm_called: false
                },
                ticket_info:  {
                    info: '',
                    credit_cost:    0,
                    start_time:     0,
                    ticket_started: false,
                    ticket_paid:    false
                },
                tip_goal: {},
                reconnecting_interval: null,
                bypass_vjs_close:      false
            };

            // reset flussonic webRTC publisher/player objects
            _data.flussonic.pub_obj    = null;
            _data.flussonic.player_obj = null;
            _data.flussonic.pub_inputs = {
                video: null,
                audio: null
            };
            _data.flussonic.active_devices = {
                video: null,
                audio: null
            };

            if (_data.vc.reconnecting_interval) {
                clearInterval(_data.vc.reconnecting_interval);
                _data.vc.reconnecting_interval = null;
            }

            _data.override_mobile_chat_limit = false; // might not really need this after all
            _data.suppress_scroll = false;
            _data.mobile_height_check = false;
            _data.initial_user_set = false;
            _data.profile_redirect_pending = false;
            _data.execute_on_handshake = false;      // function to run on successful handshake with push/CometD
            _data.debug_rtc_peer_stats = false;
        },
        user:      {},
        duid:      null, // logged in user's duid (i.e. JS equivalent of $auth->auth['duid'])
        username:  null,
        membership: 'FREE',
        free_user: true,
        seeking:   ["WOMAN", "COUPLE"],

        ajax_module: null,

        // mobile chat scroll height exceeded viewport
        mobile_height_check: false,
        override_mobile_chat_limit: false,
        suppress_scroll: false,
        profile_redirect_pending: false,
        execute_on_handshake: false,

        // mux data env key for video player/playback stats
        mux_env_key: 'cn3e5ab43k59ovc6ti0vsgf25', // prod

        // debug RTCPeerConnection with getStats() report
        debug_rtc_peer_stats: false,

        initial_user_set: false,
        reload_tries:  0,
        errors_logged: 0,

        https:     false,
        chrome_60: false,

        // available rooms
        rooms:        null,
        // room user is currently in
        current_room: {},
        // users in current_room
        users:        null,
        // keep track of all our subscriptions
        subscriptions: {},

        sub_success: {
            admin: false,
            rooms: false,
            join_room: false,
            leave_room: false,
        },

        // channel subscriptions for chat in general (rooms list, join/leave room service channels etc...)
        chat_subscriptions: {},

        // channel subscriptions for a specific room
        room_subscriptions: {},

        // blocked users
        blocked_users: [],

        // flag for checking if this chat session is videochat or regular group chat
        is_videochat: false,

        // easy place to store/refer to flussonic publisher and video player objects
        flussonic: {
            pub_obj:    null,
            player_obj: null,
            pub_inputs: {
                video: null,
                audio: null
            },
            // deviceId's for active video and audio devices
            active_devices: {
                video: null,
                audio: null
            }
        },

        // videochat specific data
        vc: {
            type:          'NORMAL', // NORMAL, TICKET, PPM or PRIVATE
            room_id:       null,     // previously _data.wowza_duid (duid of user who's on camera/streaming/publisher)
            username:      null,     // previously _data.wowza_username
            state:         null,
            tip_sound:     null,
            play_tip_sound: true,
            is_publisher:  false,
            initializing:  false,

            retry_count: 0,

            switch_url: null,         // used for switching source of stream (private/normal etc)

            private_room: false,      // previously _data.private_room (flag for private room or not)
            ppm_cost: 0,
            private_info: {
                url:              null,  // url for private/ppm chats that will use authentication hooks for verification
                watcher_duid:     null,  // previously _data.private_duid (aka watcher_duid/user watching the stream)
                private_paid:     false, // flag for if user has access to watch the private stream (i.e. did the pay)
                start_ppm_called: false
            },
            ticket_info:  {
                info: '',
                credit_cost:    0,
                start_time:     0,
                ticket_started: false,
                ticket_paid:    false
            },

            tip_goal: {},
            reconnecting_interval: null,
            bypass_vjs_close:      false
        }
    };

});

